import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import each from 'lodash/each';

/**
 * Looks up the requested path property from the specified object. Can return a single property value but can also
 * navigate through any unindexed array properties encountered.
 *
 * This method currently brute-forces it way through every property on the object, recursively. At each leaf/endpoint
 * property encountered it will be examined to see if it's a match for the requested path. This can probably be
 * implemented in a more efficient manner in the future.
 *
 * @param {Object} object
 * @param {String} requestPath
 */
function resolvePath (object, requestPath)
{
  let result = null;

  // iterates through the object recursively calling itself if a sub-objects or arrays are encountered.
  function iterate (obj, root)
  {
    let isarr = isArray(obj);
    each(obj, (value, key) => {
      let path = root + (isarr ? '[' + key + ']' : key);

      if (isArray(value))
      {
        iterate(value, path);
      }
      else if (isObject(value))
      {
        iterate(value, path + '.');
      }
      else
      {
        if (hasMatch(path))
        {
          if (result === null)
          {
            result = value;
          }
          else if (isArray(result))
          {
            result.push(value);
          }
          else
          {
            result = [result, value];
          }
        }
      }
    });
  }

  // checks if the specified matches the requested path.
  function hasMatch (path)
  {
    let pathSplits = path.split('.');
    let requestSplits = requestPath.split('.');
    // quit early if possible
    if (pathSplits.length !== requestSplits.length)
    {
      return false;
    }

    // else, spin through all path pieces checking each portion for equality. exact matches are allowed as well as
    // if the requested part is unindexed and the current path is indexed. for example, if the current path is
    // "submittedBy[0].sortName" and the requested path is "submittedBy.sortName" we'll accept that.
    let match = true;
    each(pathSplits, (pathSplit, i) => {
      if (pathSplit !== requestSplits[i])
      {
        let patchMatch = pathSplit.match(/(.+)\[\d+\]$/);
        let requestMatch = requestSplits[i].match(/(.+)\[\d+\]$/);

        if (!((patchMatch !== null && requestMatch === null) &&
            (patchMatch[1] === requestSplits[i])))
        {
          match = false;
        }
      }
    });

    return match;
  }

  iterate(object, '');
  return result;
}

export default
{
  resolvePath
};
